var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerra2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 52 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ebbb6cda-0389-45d8-bb1c-376d5bf36abc",
    x1: 35.55,
    y1: 48.97,
    x2: 35.55,
    y2: 24.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4366c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3458b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2348ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#193fa5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163ca3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f31efcdf-db45-41d1-9fdf-f0c98c440807",
    x1: 28.73,
    y1: 22.86,
    x2: 28.73,
    y2: 0,
    xlinkHref: "#ebbb6cda-0389-45d8-bb1c-376d5bf36abc"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fccc71bd-5025-4d54-b43c-83ee4283abe6",
    x1: 2.68,
    y1: 8.02,
    x2: 19.28,
    y2: 8.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58c66b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5491f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f353812a-3fef-4520-a39f-fc15f94407a0",
    x1: 0,
    y1: 32.68,
    x2: 16.02,
    y2: 32.68,
    xlinkHref: "#fccc71bd-5025-4d54-b43c-83ee4283abe6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae916250-479e-4f6a-ba90-eed93ba23120",
    x1: 14.03,
    y1: 20.12,
    x2: 52,
    y2: 20.12,
    xlinkHref: "#fccc71bd-5025-4d54-b43c-83ee4283abe6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abdf6be7-d18d-4907-97fe-9b3e82537090",
    x1: 33.83,
    y1: 43.42,
    x2: 48.69,
    y2: 43.42,
    xlinkHref: "#fccc71bd-5025-4d54-b43c-83ee4283abe6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ae6f7ef0-565d-4a22-8f2c-325befffa09b",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bcd3e4b3-41de-4e5f-b039-dc1868c624a4",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.36,39.82c1.43,5.28,6.54,9.31,9.12,9.15.09,0,9.79-1.82,15.1-10.71,4.13-6.92,2.73-13.6-2.89-13.75-2,.15-24,5.25-21.33,15.31",
    fill: "url(#ebbb6cda-0389-45d8-bb1c-376d5bf36abc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.16,5.9h0a24.63,24.63,0,0,0-26-3.76,14.3,14.3,0,0,0-1.57.77c-.34.18-.69.37-1,.57l.09,0A11.17,11.17,0,0,0,12.05,6C5,15.33,28.7,22.15,41.39,22.17,47.23,26.37,48.87,10.35,43.16,5.9Z",
    fill: "url(#f31efcdf-db45-41d1-9fdf-f0c98c440807)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,6.09C15.34,11,4.48,14.46,2.69,13.92v0l.22-.45A26.58,26.58,0,0,1,5,10,26.57,26.57,0,0,1,10.65,4.4,23.91,23.91,0,0,1,12.72,3a7.6,7.6,0,0,1,3.59-1c4.84.09,2.31,4,2.29,4",
    fill: "url(#fccc71bd-5025-4d54-b43c-83ee4283abe6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.92,40.79c.24,1.54,0,7.63-.32,8.15-.27,0-.83.05-2.47-.87a24,24,0,0,1-2.48-1.62,26,26,0,0,1-3-2.6,25.13,25.13,0,0,1-2.6-3,25.44,25.44,0,0,1-3.69-7.15,25.27,25.27,0,0,1-1-4,26.42,26.42,0,0,1,0-8.45,25.81,25.81,0,0,1,1-4q.12-.39.27-.78h0c1.87,2.5,4,4.76,5.89,7.28s4.17,6.32,4.66,7.16c3,5.19,3.54,8.4,3.77,9.94",
    fill: "url(#f353812a-3fef-4520-a39f-fc15f94407a0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,25.43A26.06,26.06,0,0,1,50.19,35c-3.06,3.29-23.71-4.82-23.91-4.91-2.83-1.24-11.42-5-12.2-10.94C13,10.62,30.23,4.68,37.82,4.45c.91,0,3.68,0,5.29,1.36A26,26,0,0,1,52,25.43",
    fill: "url(#ae916250-479e-4f6a-ba90-eed93ba23120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,48.53c-2.25,1.06-4.73.29-4.08-1.91,1.23-4.21,12-8.54,14.41-8.77.29,0,.42.17.29.4A26.34,26.34,0,0,1,38,48.53",
    fill: "url(#abdf6be7-d18d-4907-97fe-9b3e82537090)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerra2);
export default __webpack_public_path__ + "static/media/terra2.3b8a4497121229ac69ab6afa1c4e9317.svg";
export { ForwardRef as ReactComponent };